import React, {Component} from 'react';
import {Form, Input,Select,Modal, Button,message} from 'antd';	
import { connect } from 'react-redux';


import {assignStaffAPI} from '@/API'
import {assgnModalTitleMapList} from '../constData'

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

class AssignStaffModal extends Component{
	state={
		postForm:{
			name:'',
			sign_user:undefined,//标记员
			sign_check_user:undefined,//标记审核员
			icon_user:undefined,//插画师
			icon_check_user:undefined,//插画审核员
			check_user:undefined,//题目审核员
		},
		btnLoading:false,
		title:''
	}
	componentDidMount(){
		this.getModalTitle()
	}
	getModalTitle(){
		let title=''
		assgnModalTitleMapList.forEach(v=>{
			if(v.key=this.props.assginType)title=v.title
		})
		this.setState({title})
	}
	resetPostForm(){
		let initPostForm={
			name:'',
			sign_user:undefined,//标记员
			sign_check_user:undefined,//标记审核员
			icon_user:undefined,//插画师
			icon_check_user:undefined,//插画审核员
			check_user:undefined,//题目审核员
		}
		this.setState({postForm:initPostForm})
	}
	//todo  taskid assigntype
	handleSubmit = (e) => {
		let {assignType,taskId}=this.props
	    e.preventDefault();
	    this.props.form.validateFieldsAndScroll((err, values) => {
	      if (!err) {
			let {postForm}=values
			postForm.task_id=taskId
	        this.setState({btnLoading:true})
	      	 assignStaffAPI(assignType,postForm).then(res=>{
	      	 	message.success('分配成功！');
	      	 	this.setState({btnLoading:false})
	      	 	this.props.handleClose('update')
	      	 	this.props.form.resetFields();
	      	 }).catch(e=>{
	      	 	this.setState({btnLoading:false})
	      	 })
	      }
	    });
	 }
	
	getAssignOptions(assignType){
		let { sign_user_list,sign_check_user_list,icon_user_list,icon_check_user_list,check_user_list}=this.props.memberList
		let assignOptions=[]
		switch (assignType){
			case 'sign_user':
				assignOptions=[{
					label:'标记员',
					key:'sign_user',
					options:sign_user_list.map(v => <Option value={v.id}  key={v.id}>{v.username}</Option>)
				}]
				break;
			case 'sign_check_user':
				assignOptions=[{
					label:'标记审核员',
					key:'sign_check_user',
					options:sign_check_user_list.map(v => <Option value={v.id}  key={v.id}>{v.username}</Option>)
				}]
				break;
			case 'icon_user':
				assignOptions=[{
					label:'插画师',
					key:'icon_user',
					options:icon_user_list.map(v => <Option value={v.id}  key={v.id}>{v.username}</Option>)
				}]
				break;
			case 'icon_check_user':
				assignOptions=[{
					label:'插画审核员',
					key:'icon_check_user',
					options:icon_check_user_list.map(v => <Option value={v.id}  key={v.id}>{v.username}</Option>)
				}]
				break;
			case 'check_user':
				assignOptions=[{
					label:'题目审核员',
					key:'check_user',
					options:check_user_list.map(v => <Option value={v.id}  key={v.id}>{v.username}</Option>)
				}]
				break;
			//分配插画师和插画审核员
			case 'icon_and_check_user':
				assignOptions=[{
					label:'插画师',
					key:'icon_user',
					options:icon_user_list.map(v => <Option value={v.id}  key={v.id}>{v.username}</Option>)
				},{
					label:'插画审核员',
					key:'icon_check_user',
					options:icon_check_user_list.map(v => <Option value={v.id}  key={v.id}>{v.username}</Option>)
				}]
				break;
			default:
				break;
		}
		
		return assignOptions
	}
	renderForm(){
		
		const ruleOption={
			input:{rules: [{ required: true, message: '必填项!', whitespace: true }]},

		}

		const { getFieldDecorator } = this.props.form;
		let assignOptions=this.getAssignOptions(this.props.assignType)
	

	   return(
	    		<Form >
	    			{
	    				assignOptions.map((v,i)=>{
	    					return(
	    						 <FormItem key={i} {...formItemLayout} label={v.label} hasFeedback>
					          {getFieldDecorator(`postForm.${v.key}`, ruleOption.input)(
					          	<Select
				       				showSearch
							        defaultActiveFirstOption={false}
							        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
							      >
				       				{v.options}
				       			 </Select>
					          )}
					        </FormItem>
	    					)
	    				})
	    			}

			</Form>
	    )
		
	}
	
	render(){
		let {btnLoading,title}=this.state
		let {openAssign,handleClose}=this.props
		
		return(
			<Modal
	          title={title}
	          visible={openAssign}
	          onCancel={handleClose}
	          footer={[
	            <Button key="cancel"  onClick={handleClose}>取消</Button>,
	            <Button key="save" type="primary"  loading={btnLoading} onClick={this.handleSubmit}>保存</Button>,
	          ]}
	        >
				{this.renderForm()}
			 </Modal>
		)
	}
}


export const WrappedAssignStaffForm = Form.create()(AssignStaffModal)



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/modal/assign_staff.js